export const EXPERIMENT_RDC_JOB = 'web-ui-jobs-rdc';
export const INITIAL_RDC_OFFSET = 1;
export const LS_LAST_CLOUD_TYPE = 'lastCloudTypeJobs';
export const REAL_DEVICE_CLOUD = 'real_device_cloud';
export const VIRTUAL_DEVICE_CLOUD = 'virtual_device_cloud';

export const CLOUD_TYPES = [REAL_DEVICE_CLOUD, VIRTUAL_DEVICE_CLOUD];
export const DEFAULT_CLOUD_TYPE = VIRTUAL_DEVICE_CLOUD;

export const TAB_REAL = 'rdc';
export const TAB_VIRTUAL = 'vdc';
export const DEFAULT_TAB = TAB_VIRTUAL;
export const TABS = {
  [TAB_REAL]: REAL_DEVICE_CLOUD,
  [TAB_VIRTUAL]: VIRTUAL_DEVICE_CLOUD,
};
